import { Box, Button, Input, InputField, Text, VStack } from "components/ui";
import SwitchFilter from "components/ui/SwitchFilter";
import { Typography } from "components/ui/Typography";
import { useRouter } from "expo-router";
import React, { useCallback } from "react";
import { ItemCategoryRead, ItemSubCategoryRead, useGetCategoryQuery } from "store/abcoApi";
import { debounce } from "utils/globalFunctions";
import { useFilterSettings } from "utils/hooks/useFilterSettings";
import { useScroll } from "utils/hooks/useScroll";

type Props = {
	category: ItemCategoryRead | null;
	subCategory: ItemSubCategoryRead | null;
	onChange?: (value: any) => void;
	setSearchTerm?: (value: string) => void;
	isCore?: boolean;
	isInStock?: boolean;
	setIsCore?: (value: boolean) => void;
	setIsInStock?: (value: boolean) => void;
};

const SitesFilterList = ({ setSearchTerm, isCore, setIsCore, isInStock, setIsInStock, onChange }: Props) => {
	const [filterState, setFilterState] = React.useState({});

	const [searchInputValue, setSearchInputValue] = React.useState("");

	const debouncedSearch = useCallback(
		debounce((text: string) => {
			if (setSearchTerm) setSearchTerm(text);
			setFilterValue("searchTerm", text);
		}, 300),
		[setSearchTerm],
	);

	React.useEffect(() => {
		return () => {
			debouncedSearch.cancel();
		};
	}, [debouncedSearch]);

	function setFilterValue(key: string, value: any) {
		const newState = {
			...filterState,
			[key]: value,
		};
		setFilterState(newState);
		if (onChange) {
			onChange(newState);
		}
	}

	function clearAllFilters() {
		const newState = {
			isCore: null,
			inStock: null,
		};
		setFilterState(newState);
		if (setIsCore) setIsCore(false);
		if (setIsInStock) setIsInStock(false);
		if (onChange) {
			onChange(newState);
		}
	}

	return (
		<Box>
			<Box
				sx={{
					// position: "sticky",
					top: 28,
					zIndex: 100,
					// backgroundColor: "$basicwhite",
					borderBottomWidth: 1,
					borderColor: "$neutral100",
				}}
				// display={isFilterOpen ? "flex" : "none"}
			>
				{/* {renderCategoryDropdown()} */}
				<Box paddingVertical={12}>
					<Box position="relative">
						<Input sx={{ paddingBlock: 12, paddingHorizontal: 6 }} bg="$basicwhite" borderRadius={8} borderColor="$neutral300" variant="outline" size="md">
							<InputField
								value={searchInputValue}
								onChangeText={(text) => {
									setSearchInputValue(text);
									debouncedSearch(text);
								}}
								placeholder="Search for..."
							/>
						</Input>
					</Box>
					{/* <SearchBar fluid inline onChangeText={setSearchTerm} /> */}
				</Box>

				<Box borderRadius={12} paddingHorizontal={12} paddingVertical={16} bg="$basicwhite">
					<Box flexDirection="column">
						<Box justifyContent="space-between" flexDirection="row" alignItems="flex-end">
							<Text fontWeight={"bold"} fontSize={20}>
								Filter
							</Text>
							<Button onPress={clearAllFilters}>
								<Typography
									sx={{
										color: "$primarylight",
										marginLeft: "auto",
									}}
								>
									Clear all
								</Typography>
							</Button>
						</Box>
						<VStack paddingVertical={16}>
							<SwitchFilter
								text="Is core?"
								value={isCore}
								onChange={(value) => {
									if (setIsCore) setIsCore(value);
									setFilterValue("isCore", value);
								}}
							/>
							<SwitchFilter
								text="In stock?"
								value={isInStock}
								onChange={(value) => {
									if (setIsInStock) setIsInStock(value);
									setFilterValue("inStock", value);
								}}
							/>
							{/* <SwitchFilter defaultValue={true} text="Show offers" isLastItem /> */}
						</VStack>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

export default SitesFilterList;
